import { Component } from '@angular/core';

@Component({
  selector: 'lib-footer',
  imports: [],
  templateUrl: './footer.html',
  styles: ``,
})
export class Footer {}
